import { useEffect, useRef } from 'react'

const STAR_COUNT = 160

const Starfield = () => {
    const containerRef = useRef(null)

    useEffect(() => {
        const container = containerRef.current
        if (!container) return

        for (let i = 0; i < STAR_COUNT; i++) {
            const star = document.createElement('div')
            star.className = 'star'
            const size = Math.random() < 0.8
                ? (Math.random() * 1.5 + 0.5)
                : (Math.random() * 2.5 + 1.5)
            const a = (Math.random() * 0.25 + 0.1).toFixed(2)
            const b = (Math.random() * 0.55 + 0.35).toFixed(2)
            star.style.cssText = `
                width:${size}px; height:${size}px;
                left:${Math.random() * 100}%;
                top:${Math.random() * 100}%;
                --d:${(Math.random() * 4 + 2).toFixed(1)}s;
                --a:${a}; --b:${b};
                animation-delay:${(Math.random() * 6).toFixed(1)}s;
            `
            container.appendChild(star)
        }

        return () => {
            container.innerHTML = ''
        }
    }, [])

    return <div className="stars" ref={containerRef} />
}

export default Starfield
